import Reflux from "reflux";
import clone from "lodash/clone";

/**
 * Utility methods for Reflux stores.
 * @namespace
*/
const StoreUtil = {

	/**
	 * A factory method that returns a new Reflux store with some utility methods
	 * attached to it.
	 * @param  {Object} actions  A set of reflux actions, usually created in a
	 *                           project's actions file.
	 * @param  {Object} [params] Options for creating the store.
	 * @return {Object}          A Reflux store.
	*/
	createStore(actions, params) {
		let _p = {
			listenables: actions,
			data: {},

			// standard setters/getters
			get(key) {
				return this.data[key];
			},

			getAll() {
				let data = {};

				if (params.noClone) {
					({ data } = this);
				} else {
					Object.keys(this.data || {}).forEach((name) => {
						const value = this.data[name];
						data[name] = clone(value);
					});
				}

				return data;
			},

			set(bundle) {
				Object.keys(bundle || {}).forEach((name) => {
					const value = bundle[name];
					this.data[name] = value;
				});

				// use this to generate calculated values
				if (typeof this.onUpdate === "function") {
					this.onUpdate(bundle);
				}

				return this.trigger(bundle);
			}
		};

		// mix their stuff in
		_p = {
			..._p,
			...params,
		};

		return Reflux.createStore(_p);
	}
};

export default StoreUtil;



// WEBPACK FOOTER //
// ./src/shared/util/StoreUtil.js